import { toChildArray } from 'preact';
import { useRef } from 'preact/hooks';
import { SvgIcon } from '@/features/form';
import { mapBrFromString, makeClassName } from '@/utils';
import HandleTabIndex from './HandleTabIndex';

/* Presentational Types */

export default function GroupTitle({
	children,
	block,
	requiredMarkLabel = '',
	...props
}) {
	const focus = useRef(false);
	const isSingleLine =
		typeof children === 'string' && children.split(/<br\s*\/?>/gi).length === 1;

	const WrappingElement =
		['textarea', 'input', 'contact'].indexOf(block.typeName) > -1 ? 'div' : 'legend';

	return block.typeName !== 'section_break' ? (
		<WrappingElement
			class="block-title"
			id={`block-title-${block.typeName}-${block.id}${
				block.typeName === 'special_input' ? `-${props._id}` : ''
			}`}
			tabIndex="-1" //needed to keep tab focus order intact after reading (onclick) this element with a screenreader.
		>
			{block.typeName !== 'special_input' &&
			block.typeName !== 'textarea' &&
			block.typeName !== 'input' ? (
				<span>
					{toChildArray(children).map(child =>
						mapBrFromString(child, props.required ? requiredMarkLabel : false)
					)}
				</span>
			) : (
				<label
					for={
						block.typeName === 'special_input'
							? `element-${block.typeName}-${block.id}-${props._id}`
							: ['textarea', 'input'].indexOf(block.typeName) > -1
							? `element-${block.typeName}-${block.id}`
							: null
					}
					onKeyDown={() => {
						focus.current = !block.tooltip ? true : false;
					}}
				>
					{toChildArray(children).map(child =>
						mapBrFromString(child, props.required ? requiredMarkLabel : false)
					)}
					{block.properties?.placeholder && (
						<span className={makeClassName('input-placeholder-helper')}>
							{block.properties?.placeholder}
						</span>
					)}
				</label>
			)}
			{block.tooltip && isNaN(block.tooltip) ? (
				<HandleTabIndex
					component="div"
					useTabIndexWhenOpen
					role="tooltip"
					class="tooltip"
					aria-label={block.tooltip}
				>
					<SvgIcon
						icon="question"
						alt="questionmark icon"
					/>
					<div aria-label={block.tooltip}>{mapBrFromString(block.tooltip)}</div>
				</HandleTabIndex>
			) : null}
			{props.required && isSingleLine ? <span class="required-mark">*</span> : null}
		</WrappingElement>
	) : (
		<h3
			class="section-title"
			tabIndex="-1"
		>
			{toChildArray(children).map(child => mapBrFromString(child))}
		</h3>
	);
}
